import styled from '@emotion/styled'
import { Flex } from 'lese'

export default styled(Flex)`
  height: auto;
  padding-top: 25px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const Row = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
`

export const Col = styled.div`
  order: 1;
  padding: 5px;
  display: flex;
  align-self: center;
  flex-direction: column;
  margin: auto;
`
export const DataContainer = styled.div`
  background-color: #fff;
  padding: 20px 30px;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12),
    0 2px 4px -1px rgba(0, 0, 0, 0.3);
  margin-top: 20px;
  max-width: 65vw;
  min-width: 65vw;
`
